import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import UserPanel from "./UserPanel.js";
import { getMetricsData } from "../../services/api/logsService.ts";
import importedFormations from "../../CommonData/Data/formation.js";
import { Progress } from "reactstrap";
import ServerHealth from "./ServerHealth.js";
import UserChart from "./UserChart.js";
import OverView from "./OverView.js";



const Dashboard = () => {
  const [formations, setFormations] = useState([]);
  const [userlvl, setUserlvl] = useState(0);
  const [storage, setStorage] = useState({
    size: "0",
    used: "0",
    available: "0",
    percent: "0%",
  });
  const [metrics, setMetrics] = useState({
    totalUsers: 0,
    totalCreators: 0,
    averageScore: 0,
    totalChapters: 0,
  });
  const [metricsLoading, setMetricsLoading] = useState(true);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("authUser"));
    if (userData) setUserlvl(userData.user_ROLE_ID);

    fetchMetrics();
    setFormations(importedFormations);
  }, []);

  useEffect(() => {
    fetch("/api/logs/storage")
      .then(res => res.json())
      .then(data => setStorage(data));
  }, []);


  const fetchMetrics = async () => {
    try {
      setMetricsLoading(true);
      const data = await getMetricsData();
      setMetrics(data);
    } catch (error) {
      console.error("Erreur métriques :", error);
    } finally {
      setMetricsLoading(false);
    }
  };


  document.title = "Dashboard | iXiMANAGER";
  console.log("USER LVL =", userlvl);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {[1, 2].includes(userlvl) && (
            <>
              {/* UserPanel avec toutes les métriques */}
              {metricsLoading ? (
                <p className="text-center">Chargement des données...</p>
              ) : (
                <UserPanel metrics={metrics} />
              )}

              <Row className="mt-4">
                <OverView userlvl={userlvl} />
              </Row>

              <Row className="mt-4">
                <Card>
                  <ServerHealth />
                </Card>
              </Row>

              {/* Exemple d'autres sections du dashboard 
              <Row>
                <Col lg={12}>
                  <Card>

                  </Card>
                </Col>
              </Row>
              */}

            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
